import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';
import { appRoutes } from '../routes';

export const useInternalRoutes = () => {
  const [searchParams] = useSearchParams();

  const routes = useMemo(
    () => ({
      home: {
        build: () => appRoutes.home.build({ searchParams }),
      },
      category: {
        build: (slug: string, page?: number) =>
          appRoutes.category.build({ slug, page, searchParams }),
      },
      search: {
        build: (criteria: string, page?: number) =>
          appRoutes.search.build({ criteria, searchParams, page }),
      },
    }),
    [searchParams],
  );

  return routes;
};
